import { useEffect } from 'react';

/**
 * Keeps the search overlay and the snapshot popovers (alerts, account) mutually exclusive. They
 * each own their open state, so they announce themselves here when they open and every other
 * one closes itself in response. Help & Support is deliberately not part of this (matches prod).
 */
const NAV_FLYOUT_OPEN_EVENT = 'sxm:nav-flyout-open';

export type NavFlyoutSource = 'account' | 'alerts' | 'search';

export function announceNavFlyoutOpen(source: NavFlyoutSource): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent<NavFlyoutSource>(NAV_FLYOUT_OPEN_EVENT, { detail: source }));
}

export function useCloseOnOtherNavFlyoutOpen(source: NavFlyoutSource, onClose: () => void): void {
    useEffect(() => {
        const handler = (event: Event) => {
            if ((event as CustomEvent<NavFlyoutSource>).detail !== source) {
                onClose();
            }
        };
        window.addEventListener(NAV_FLYOUT_OPEN_EVENT, handler);
        return () => window.removeEventListener(NAV_FLYOUT_OPEN_EVENT, handler);
    }, [source, onClose]);
}
